import { Component, computed, inject, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AppRoutes } from '../../constants/routes.const';
import { AuthService } from '../../services/auth.service';
import { LayoutService } from '../../services/layout.service';
import {
  canAccessApp,
  canAccessOmbudsmanModule,
  canAccessOneOnOneModule,
  canAccessTimeTrackingModule,
  canManageRecruitment,
  canManageTimeTracking,
  canReadRoles,
  canReviewTimeTracking,
  isAdminRole,
} from '../../utils/permissions.utils';
import { UserAvatarComponent } from '../user-avatar/user-avatar.component';

@Component({
  selector: 'app-sidebar',
  imports: [RouterLink, RouterLinkActive, UserAvatarComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  authService = inject(AuthService);
  layoutService = inject(LayoutService);
  isSettingsOpen = signal(false);
  isHoursOpen = signal(true);
  isAdmin = computed(() => isAdminRole(this.authService.userClaims()));
  canSeeMainApp = computed(() => canAccessApp(this.authService.userClaims()));
  canSeeSettings = computed(() => canAccessApp(this.authService.userClaims()));
  canSeeRoles = computed(() => canReadRoles(this.authService.userClaims()));
  canSeeRecruitment = computed(() =>
    canManageRecruitment(this.authService.userClaims())
  );
  canManageEmailTemplates = computed(() =>
    canManageRecruitment(this.authService.userClaims())
  );
  canSeeTimeTracking = computed(() =>
    canAccessTimeTrackingModule(this.authService.userClaims())
  );
  canSeeOneOnOne = computed(() =>
    canAccessOneOnOneModule(this.authService.userClaims())
  );
  canSeeOmbudsman = computed(() =>
    canAccessOmbudsmanModule(this.authService.userClaims())
  );
  canManageHours = computed(() =>
    canManageTimeTracking(this.authService.userClaims())
  );
  canReviewHours = computed(() =>
    canReviewTimeTracking(this.authService.userClaims())
  );
  protected readonly AppRoutes = AppRoutes;
}
